import type { BranchComparisonReport } from '@sellokart/shared';
import { portalApi, queryString } from '@/lib/api';
import type { ReportFilters } from './useReportFilters';

export const branchComparisonKeys = {
  report: (from: string, to: string) => ['reports', 'branch-comparison', from, to] as const,
};

/** Takes only the range — the report is the split across every branch, so a branch filter means nothing here. */
export function fetchBranchComparison(
  filters: Pick<ReportFilters, 'from' | 'to'>,
  signal?: AbortSignal,
): Promise<BranchComparisonReport> {
  const query = queryString({ from: filters.from, to: filters.to });
  return portalApi.get<BranchComparisonReport>(`/portal/reports/branch-comparison${query}`, { signal });
}
